"use client";

import React from "react";
import NextImage from "@/components/common/NextImage";

interface HeroSlideProps {
  imageUrl: string;
  mobileUrl?: string;
  navigationLink: string;
  altText: string;
  priority?: boolean;
}

const HeroSlide: React.FC<HeroSlideProps> = ({
  imageUrl,
  mobileUrl,
  navigationLink,
  altText,
  priority = false,
}) => {
  const displayMobileUrl = mobileUrl?.trim() || imageUrl;

  return (
    <div className="relative w-full h-full overflow-hidden select-none">
      <a
        href={navigationLink}
        className="block w-full h-full outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-amber-500 rounded-xl"
        tabIndex={0}
        aria-label={altText}
      >
        {/* Desktop Image */}
        <div className={`hidden md:block relative w-full h-full`}>
          <NextImage
            src={imageUrl}
            alt={altText}
            fill
            sizes="(max-width: 1024px) 100vw, 70vw"
            priority={priority}
            className="object-cover transition-transform duration-700 ease-out hover:scale-[1.01]"
          />
        </div>

        {/* Mobile Image */}
        <div className={`block md:hidden relative w-full h-full`}>
          <NextImage
            src={displayMobileUrl}
            alt={altText}
            fill
            sizes="100vw"
            priority={priority}
            className="object-cover transition-transform duration-700 ease-out"
          />
        </div>
      </a>
    </div>
  );
};

export default React.memo(HeroSlide);
